import { Pipe, PipeTransform } from '@angular/core';

/**
 * Removes visual media elements (img, picture, video, iframe) from an HTML
 * string so text-only previews (e.g. profile comment preview) never render
 * embedded images. When `imagePlaceholder` is provided, images are replaced
 * by that text instead of silently removed, so image-only content still
 * produces a visible preview.
 */
@Pipe({
  name: 'stripHtmlImages',
  standalone: true,
})
export class StripHtmlImagesPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    imagePlaceholder?: string
  ): string {
    if (!value) return '';

    const doc = new DOMParser().parseFromString(value, 'text/html');
    doc.body.querySelectorAll('img, picture').forEach((element) => {
      if (imagePlaceholder && element.parentNode) {
        element.replaceWith(doc.createTextNode(imagePlaceholder));
        return;
      }
      element.remove();
    });
    doc.body
      .querySelectorAll('video, iframe')
      .forEach((element) => element.remove());

    return doc.body.innerHTML;
  }
}
